import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
// import { useAssessmentSectionScores } from '../hooks/useAssessmentSectionScores';
import {
  getPublishedReportById,
  type AssessmentReport,
} from '../hooks/useGetAssessmentReport';
// import { AssessmentReportDisplay } from '../components/assessment/AssessmentReportDisplay';
import { AssessmentReportNewDisplay } from '../components/assessment/AssessmentReportDisplay_NEW';
import { Spinner } from 'react-bootstrap';

const ViewPublishedReport: React.FC = () => {
  const { reportId } = useParams<{ reportId: string }>();
  const [report, setReport] = useState<
    | (AssessmentReport & { published: string; status: string; id: string })
    | null
  >(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchReport = async () => {
      if (reportId) {
        setLoading(true);
        const fetchedReport = await getPublishedReportById(reportId);
        setReport(fetchedReport);
        setLoading(false);
      }
    };

    fetchReport();
  }, [reportId]);

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: '100vh' }}
      >
        <Spinner animation="border" />
      </div>
    );
  }

  if (!report) {
    return <div>No report available for this assessment.</div>;
  }

  // if (!sectionScores || sectionScores.length === 0) {
  //   return <div>No section scores available for this assessment.</div>;
  // }

  return (
    <div>
      <AssessmentReportNewDisplay report={report} />

      {/* {sectionScores.map((section) => (
        <div key={section.sectionId} style={{ marginBottom: '20px' }}>
          <h2>{section.sectionName}</h2>
          <p>
            Score: {section.score} / {section.maxScore} ({section.percentage}%)
          </p>
          <div
            style={{
              background: '#e0e0e0',
              borderRadius: '4px',
              overflow: 'hidden',
              height: '20px',
              width: '100%',
            }}
          >
            <div
              style={{
                width: `${section.percentage}%`,
                background: '#76c7c0',
                height: '100%',
              }}
            ></div>
          </div>
        </div>
      ))} */}
    </div>
  );
};

export default ViewPublishedReport;
